<template lang="pug">
el-menu.navbar(mode="horizontal")
  hamburger.hamburger-container(
    v-stream:click="toggleSideBar$"
    :is-active="sidebarStatus"
  )
  levelbar
  .avatar-container
    .username {{ userName || '未登录' }}
    icon-svg.logout(
      icon-class="Logout"
      @click.native="logout"
    )
</template>

<script>
import Hamburger from '@/components/Hamburger';
import store from '../../store/sideBar';
import Levelbar from './Levelbar';
import { getUserInfo, logout } from '../../utils/auth';

export default {
  components: {
    Levelbar,
    Hamburger
  },
  computed: {
    userName() {
      return `${getUserInfo().user.userName} - ${getUserInfo().user.role}`;
    }
  },
  domStreams: ['toggleSideBar$'],
  subscriptions() {
    this.toggleSideBar$
      .map(e => !e.event.msg)
      .subscribe(value => store.changeStatus(value));
    return {
      sidebarStatus: store.state
        .map(val => val.open)
    };
  },
  methods: {
    logout
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  background: rgb(37,38,58);
  border:none;
  .hamburger-container {
    height: 50px;
    line-height: 50px;
    float: left;
    padding:0 10px;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .username, .logout{
      display: inline-block;
      color:rgb(148, 151, 167);
    }
    .username{
      font-size:14px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgb(148, 151, 167);
      margin-right:20px;
    }
    .logout{
      cursor: pointer;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/Navbar.vue?0680bec4